<template>
	<td>
		<template v-if="showSpinner">
			<i class="icon icon-spinner2"></i>
		</template>
		<template v-else>
			<template v-if="isFree">
				<strong>{{ i18n.meta.free }}</strong>
			</template>
			<span v-else>
				<strong><FormattedPrice :price="price" /></strong>
				{{ isEx ? i18n.meta.excl : i18n.meta.incl }}
			</span>
		</template>
	</td>
</template>

<script>
import FormattedPrice from "@/components/FormattedPrice";
export default {
	components: { FormattedPrice },
	props: {
		price: Number,
		isEx: Boolean,
		showSpinner: Boolean,
	},
	computed: {
		i18n() {
			return this.$i18n;
		},
		settings() {
			return this.$kpsSettings;
		},
		isFree() {
			return this.price === 0;
		},
	}
};
</script>
